import styled from 'styled-components';

import { ReactComponent as Star } from '../../assets/icons/star.svg';

export const StarEmpty = styled(Star)`
  path:first-child {
    fill: transparent !important;
  }
`;
